function postMessage(element: any, message: any) {
  const id = Date.now().toString(36) + Math.random().toString(36).slice(2);
  const finalMessage = { ...message, id, source: "importer-sdk" };
  element.contentWindow?.postMessage(finalMessage, "*");
}

export default postMessage;
